import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import '../styles/OAuthPage.css';
import '../styles/WaitlistPage.css';
import { normalizeWaitlistStatus } from '../_helpers/betaWaitlist.js';
import { useT } from '../contexts/LocaleContext.jsx';
import Logo from './Logo.jsx';

// Display-name keys of the providers a signup can come from. A provider the
// URL names that is not one of these gets no "Signed up with" line: the value
// is read from the address bar, so only known names are ever shown.
const PROVIDER_NAME_KEYS = {
  google: 'waitlist.providers.google',
  twitch: 'waitlist.providers.twitch',
  apple: 'waitlist.providers.apple',
  dev: 'waitlist.providers.dev',
};

/**
 * "You're on the waitlist" (ENG-915): where a signup the closed beta's gate
 * refused (ENG-913, `beta_waitlisted`) ends up. A full page in the sign-in
 * flow's own styling, never an overlay, so nothing is ever shown over a
 * broadcast. The status rides in the query string (`?status=pending|rejected`)
 * so a refresh keeps it; anything else reads as pending.
 */
function WaitlistPage() {
  const t = useT();
  const [searchParams] = useSearchParams();
  const status = normalizeWaitlistStatus(searchParams.get('status'));
  const provider = (searchParams.get('provider') || '').toLowerCase();
  const providerKey = Object.hasOwn(PROVIDER_NAME_KEYS, provider) ? PROVIDER_NAME_KEYS[provider] : null;

  return (
    <div className="oauth-page waitlist-page" data-theme="songshake" data-status={status}>
      <div className="oauth-page-content waitlist-page-content">
        <Logo />
        <h1 className="oauth-page-title">{t(`waitlist.${status}.title`)}</h1>
        <p className="oauth-page-description">{t(`waitlist.${status}.body`)}</p>
        {status === 'pending' && providerKey && (
          <p className="oauth-page-description waitlist-page-provider">
            {t('waitlist.signedUpWith', { provider: t(providerKey) })}
          </p>
        )}
        <Link className="oauth-page-btn-back waitlist-page-home" to="/">{t('waitlist.backToHome')}</Link>
      </div>
    </div>
  );
}

export default WaitlistPage;
